import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=4e810e20&scoped=true&"
import script from "./AppNotification.vue?vue&type=script&lang=js&"
export * from "./AppNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppNotification.vue?vue&type=style&index=0&id=4e810e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e810e20",
  null
  
)

export default component.exports